import { render, staticRenderFns } from "./comTerm4.vue?vue&type=template&id=1df3a23e&scoped=true&"
import script from "./comTerm4.vue?vue&type=script&lang=js&"
export * from "./comTerm4.vue?vue&type=script&lang=js&"
import style0 from "./comTerm4.vue?vue&type=style&index=0&id=1df3a23e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df3a23e",
  null
  
)

export default component.exports